// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Button from "../../../html/Button.js";
import * as Buhta_cabinet__Dropdown from "../../../html/Dropdown.js";
import * as Buhta_cabinet__Field from "../../../html/Field.js";
import * as Buhta_cabinet__FieldNumber from "../../../../util/FieldNumber.js";
import * as Buhta_cabinet__FormView from "../../../html/FormView.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Caml_format from "melange.js/caml_format.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function NewItemDropdown$Desktop(Props) {
  let onItemBeingAdded = Props.onItemBeingAdded;
  let showDropdown = Props.showDropdown;
  let setShowDropdown = Props.setShowDropdown;
  const match = React.useState(function () {
    return "";
  });
  const setName = match[1];
  const name = match[0];
  const match$1 = React.useState(function () {
    return Buhta_cabinet__FieldNumber.empty;
  });
  const setQty = match$1[1];
  const qty = match$1[0];
  const match$2 = React.useState(function () {
    return Buhta_cabinet__FieldNumber.empty;
  });
  const setPrice = match$2[1];
  const price = match$2[0];
  const activator = function (param) {
    return JsxRuntime.jsx("button", {
      children: JsxRuntime.jsx("img", {
        src: StaticAsset.src("/static/icons/plus-24.svg")
      }),
      className: "flex items-center"
    });
  };
  return JsxRuntime.jsx(Buhta_cabinet__Dropdown.Custom.make, {
    align: "BottomLeft",
    activator: activator,
    isDropdownShown: showDropdown,
    setIsDropdownShown: setShowDropdown,
    children: JsxRuntime.jsxs(Buhta_cabinet__FormView.make, {
      onSubmit: (function (param) {
        const saleItem_item_price = Belt__Belt_Option.getWithDefault(price.value, 0);
        const saleItem_qty = Belt__Belt_Option.getWithDefault(qty.value, 0);
        const saleItem_total_amount = Belt__Belt_Option.getWithDefault(price.value, 0) * Belt__Belt_Option.getWithDefault(qty.value, 0);
        const saleItem = {
          item_type: /* ITEM_TYPE_COMMODITY */ 1,
          item_id: undefined,
          name: name,
          item_price: saleItem_item_price,
          qty: saleItem_qty,
          total_amount: saleItem_total_amount
        };
        Curry._1(onItemBeingAdded, saleItem);
        Curry._1(setShowDropdown, (function (param) {
          return false;
        }));
        Curry._1(setName, (function (param) {
          return "";
        }));
        Curry._1(setQty, (function (param) {
          return {
            value: undefined,
            text: ""
          };
        }));
        Curry._1(setPrice, (function (param) {
          return {
            value: undefined,
            text: ""
          };
        }));
      }),
      className: "grid grid-cols-1-auto gap-4 w-77.5 p-4 pt-3",
      children: [
        JsxRuntime.jsx(Buhta_components__Text.H6.make, {
          className: "cart-dropdown--header text-default-gray",
          children: "Новый товар или услуга"
        }),
        JsxRuntime.jsx("button", {
          children: JsxRuntime.jsx("img", {
            src: StaticAsset.src("/static/icons/close.svg")
          }),
          onClick: (function (param) {
            Curry._1(setShowDropdown, (function (param) {
              return false;
            }));
          })
        }),
        JsxRuntime.jsx(Buhta_cabinet__Field.make, {
          label: "Наименование",
          type_: "text",
          required: true,
          onChange: (function (value) {
            Curry._1(setName, (function (param) {
              return value;
            }));
          }),
          isDarkMode: true,
          className: "col-start-1 col-end-3",
          value: name
        }),
        JsxRuntime.jsx(Buhta_cabinet__Field.make, {
          label: "Количество",
          type_: "text",
          required: true,
          onChange: (function (value) {
            Buhta_cabinet__FieldNumber.set(setQty, value);
          }),
          isDarkMode: true,
          className: "col-start-1 col-end-3",
          value: qty.text
        }),
        JsxRuntime.jsx(Buhta_cabinet__Field.make, {
          label: "Цена",
          type_: "text",
          required: true,
          onChange: (function (value) {
            Curry._1(setPrice, (function (param) {
              let tmp;
              if (value === "") {
                tmp = undefined;
              } else {
                try {
                  tmp = Caml_format.caml_float_of_string(value);
                }
                catch (exn){
                  tmp = undefined;
                }
              }
              return {
                value: tmp,
                text: value
              };
            }));
          }),
          isDarkMode: true,
          className: "col-start-1 col-end-3",
          value: price.text
        }),
        JsxRuntime.jsx(Buhta_cabinet__Button.make, {
          type_: "submit",
          className: "col-start-1 col-end-3",
          isWide: true,
          children: "Сохранить"
        })
      ]
    })
  });
}

const Desktop = {
  make: NewItemDropdown$Desktop
};

function NewItemDropdown$Mobile(Props) {
  let onItemBeingAdded = Props.onItemBeingAdded;
  let showDropdown = Props.showDropdown;
  let setShowDropdown = Props.setShowDropdown;
  const match = React.useState(function () {
    return "";
  });
  const setName = match[1];
  const name = match[0];
  const match$1 = React.useState(function () {
    return Buhta_cabinet__FieldNumber.empty;
  });
  const setQty = match$1[1];
  const qty = match$1[0];
  const match$2 = React.useState(function () {
    return Buhta_cabinet__FieldNumber.empty;
  });
  const setPrice = match$2[1];
  const price = match$2[0];
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsx("button", {
        children: JsxRuntime.jsx("img", {
          src: StaticAsset.src("/static/icons/plus-24.svg")
        }),
        className: "flex items-center",
        onClick: (function (param) {
          Curry._1(setShowDropdown, (function (param) {
            return true;
          }));
        })
      }),
      showDropdown ? JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              className: "bg-black/80 h-screen w-full"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                      children: "Новый товар или услуга"
                    }),
                    JsxRuntime.jsx("button", {
                      children: JsxRuntime.jsx("img", {
                        className: "w-6 h-6",
                        src: StaticAsset.src("/static/icons/close.svg")
                      }),
                      onClick: (function (param) {
                        Curry._1(setShowDropdown, (function (param) {
                          return false;
                        }));
                      })
                    })
                  ],
                  className: "w-full px-6 py-3 flex justify-between items-center border-b"
                }),
                JsxRuntime.jsxs(Buhta_cabinet__FormView.make, {
                  onSubmit: (function (param) {
                    const saleItem_item_price = Belt__Belt_Option.getWithDefault(price.value, 0);
                    const saleItem_qty = Belt__Belt_Option.getWithDefault(qty.value, 0);
                    const saleItem_total_amount = Belt__Belt_Option.getWithDefault(price.value, 0) * Belt__Belt_Option.getWithDefault(qty.value, 0);
                    const saleItem = {
                      item_type: /* ITEM_TYPE_COMMODITY */ 1,
                      item_id: undefined,
                      name: name,
                      item_price: saleItem_item_price,
                      qty: saleItem_qty,
                      total_amount: saleItem_total_amount
                    };
                    Curry._1(onItemBeingAdded, saleItem);
                    Curry._1(setShowDropdown, (function (param) {
                      return false;
                    }));
                    Curry._1(setName, (function (param) {
                      return "";
                    }));
                    Curry._1(setQty, (function (param) {
                      return {
                        value: undefined,
                        text: ""
                      };
                    }));
                    Curry._1(setPrice, (function (param) {
                      return {
                        value: undefined,
                        text: ""
                      };
                    }));
                  }),
                  className: "w-full p-6",
                  children: [
                    JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                      label: "Наименование",
                      type_: "text",
                      size: "m",
                      required: true,
                      onChange: (function (value) {
                        Curry._1(setName, (function (param) {
                          return value;
                        }));
                      }),
                      value: name
                    }),
                    JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                      label: "Количество",
                      type_: "text",
                      size: "m",
                      required: true,
                      onChange: (function (value) {
                        Buhta_cabinet__FieldNumber.set(setQty, value);
                      }),
                      className: "mt-3",
                      value: qty.text
                    }),
                    JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                      label: "Цена",
                      type_: "text",
                      size: "m",
                      required: true,
                      onChange: (function (value) {
                        Curry._1(setPrice, (function (param) {
                          let tmp;
                          if (value === "") {
                            tmp = undefined;
                          } else {
                            try {
                              tmp = Caml_format.caml_float_of_string(value);
                            }
                            catch (exn){
                              tmp = undefined;
                            }
                          }
                          return {
                            value: tmp,
                            text: value
                          };
                        }));
                      }),
                      className: "mt-3",
                      value: price.text
                    }),
                    JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                      size: "m",
                      type_: "submit",
                      className: "w-full mt-4",
                      children: "Сохранить"
                    })
                  ]
                })
              ],
              className: "absolute bg-white bottom-0 rounded-t-2xl w-full"
            })
          ],
          className: "fixed inset-0 z-10"
        }) : null
    ]
  });
}

const Mobile = {
  make: NewItemDropdown$Mobile
};

export {
  Desktop,
  Mobile,
}
/* Buhta_cabinet__Button Not a pure module */
